import Api from "../Api";

const basePath = '/leasing-companies';

export default {
    getLeasingCompanies: () => Api.get(basePath)
}



// WEBPACK FOOTER //
// ./src/services/api/LeasingCompaniesService.js